import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { catchHttpError } from '@trade-platform/ui-shared';
import {
    OrderCancelReview,
    OrderCancelReviewActionTypes,
    OrderCancelReviewFailure,
    OrderCancelReviewSuccess
} from './actions';
import { OrderCancelReviewService } from './service';

@Injectable()
export class OrderCancelReviewEffects {
    private actions$ = inject(Actions);
    private orderCancelReviewService = inject(OrderCancelReviewService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderCancelReview$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OrderCancelReview>(OrderCancelReviewActionTypes.ORDER_CANCEL_REVIEW),
            switchMap(action =>
                this.orderCancelReviewService.orderCancelReview(action.payload.orderId).pipe(
                    map(_ => new OrderCancelReviewSuccess()),
                    catchHttpError(error => of(new OrderCancelReviewFailure({ error })))
                )
            )
        )
    );
}
